import React from 'react';
import logo from './logo.svg';
import './App.css';

import HistoryForm from './components/HistoryForm';

function App() {
  return (
    <div className="App">
      <HistoryForm>

      </HistoryForm>
    </div>
  );
}

export default App;
